import { action as apiAction } from 'api/Api'
import { REQUEST_UPLOAD_START } from 'store/sagas'

type Payload = {
  file: any
  cardId?: number
  boardId?: number
  onUpload?: (args: any) => void
}

const requestUploadStart = (payload: Payload) => async dispatch => {
  const { file, cardId, boardId, onUpload } = payload

  const _onUpload = async function ({ url, documentSourceId, elementId }) {
    if (onUpload) onUpload({ url, documentSourceId, elementId })
  }

  const uploadPayload: any = {
    file,
    onUpload: _onUpload
  }

  if (cardId) {
    uploadPayload.cardId = cardId
  } else {
    uploadPayload.boardId = boardId
  }

  dispatch({
    type: REQUEST_UPLOAD_START,
    payload: uploadPayload
  })
}

export default requestUploadStart
